export default "__VITE_ASSET__CyogAF1C__"